import React from 'react';

import css from './styles.css';

const LoaderCss = () => <div className={css.spinner} />;

export default LoaderCss;
